import styled from 'styled-components';

import * as mx from 'core/styles/mixins';

export const Wrapper = styled.div`
	img {
		${mx.square('100%')}
	}
`;
